<template>
    <div>
    <div class="footerBg">
        <div><el-image style="width: 100%;" :src="require('../../public/static/homeImg/footer.png')"  fit="fit"></el-image></div>

        <div class="footerBox">
            <div style="width: 18%;border-right:1px solid rgba(255,255,255,0.2);">
                <div @click="goPage('first')"><el-image style="width: 170px;" :src="require('../../public/static/homeImg/footer1.png')"  fit="fit"></el-image></div>
                <div><el-image style="width: 64px;margin-left: 20px;margin-top: 20px;" :src="require('../../public/static/homeImg/footer2.png')"  fit="fit"></el-image>
                <div style="font-size: 12px;color: #FFFFFF;margin-left: 25px;margin-top: 10px;">联系客服</div>
                </div>
            </div>
            <div style="width: 42%;margin-left: 50px;margin-right: 50px;">
                <div style="font-size: 22px;color: #FFFFFF;">快捷入口</div>
                <div class="footer_item2">
                    <div  @click="goPage('first')">首页</div>
                    <div><div>走进番茄站</div>
                    <div class="footer_item2_item">
                    <div @click="scrollToRef('section1')">公司概况</div>
                    <div @click="scrollToRef('section2')">核心优势</div>
                    <div @click="scrollToRef('section3')">行业影响力</div>
                    <div @click="scrollToRef('section4')">获得荣誉</div>
                    <div @click="scrollToRef('section5')">未来展望</div>
                </div>
                </div>
                    <div @click="goPage('third')">社会责任</div>
                    <div  @click="goPage('fourth')">湾区动态</div>
                    <div  @click="goPage('five')">联系我们</div>
                </div>
            
            </div>
            <div style="width: 40%;border-left:1px solid rgba(255,255,255,0.2);padding-left: 50px ">
                <div  style="font-size: 22px;color: #FFFFFF;">联系我们</div>
                <div  class="footer_item2_item" style="margin-top: 20px;">咨询热线：400-677-0099</div>
                <div  class="footer_item2_item" style="margin-top: 20px;">联系地址：广州市南沙区双山大道42号越秀滨海汇3楼</div>

            </div>

        </div>
        <div class="bottomStyle"><span><span style="color: #FFFFFF;"> 版权声明：&copy; 番茄站智能科技有限公司</span>
              <a style="color: rgb(92 158 255);;" :underline="false" href="https://beian.miit.gov.cn">粤ICP备2021066104号-1</a>
              <el-image style="width: 14px;margin-left: 20px;margin-top: 20px;position: relative;top: 5px;" :src="require('../../public/static/homeImg/gongan.jpg')"  fit="fit"></el-image>
              <a style="color: rgb(92 158 255);;" href="https://beian.mps.gov.cn/#/query/webSearch?code=44011502001382" rel="noreferrer" target="_blank"> 粤公网安备44011502001382号</a>
            </span></div>
    </div>
    </div>
    </template>
<script>
import { EventBus } from './eventBus'
export default {
    name: 'footerComponent', // 使用多词名称
    methods: {
        goPage(tab) {
          console.log(tab,"点击的导航");
          EventBus.$emit('custom-event', { data: tab });
        },
        scrollToRef(index){
          EventBus.$emit('scrollTop', { index: index });

        }
      }
}
</script>
<style scoped>
.footerBg:hover{
  cursor: pointer;
}
.footerBg{
    position: relative;
    padding-top: 120px;
    background: #415470;
}
.footerBox{
    position: absolute;
    top: 75px;
    left: 15%;
    width: 80%;
    display: flex;
}
.footer_item2{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

font-size: 18px;
color: #FFFFFF;
}
.footer_item2_item{
    font-size: 14px;
color: #FFFFFF;
font-weight: 200;
opacity: .7;

}
.footer_item2_item div{
    margin-top: 10px;
}
.bottomStyle{
    position: absolute;
    bottom: 30px;
    /* left: 50%; */
    width: 100%;
    text-align: center;
}
</style>